import DatePickerView from './date-picker-view';
export default DatePickerView;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/date-picker-view/index.js
// module id = null
// module chunks = 